import { toFormat } from 'core/classes/helpers/DateHelper'

export const getFormattedDate = (date: Date) => {
  return toFormat(date, 'M/DD/YYYY')
}
